import React from 'react'

// Style imports from Semantic UI
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Link } from '@ta-interaktiv/contentbricks'
import './styles.scss'

// Use object destructuring to set default values
export const Card = ({
  iframe = 'https://datawrapper.dwcdn.net/0eZom',
  titel = 'Testtitel',
  text,
  id,
  url
}) => {
  let link

  if (text) {
    link = (
      <Link allowWordWrap href={url}>
        {text}
      </Link>
    )
  }

  return (
    <div className='ui raised fluid infographic card' id={id}>
      <div className='content'>
        <p className='header'>{titel}</p>
        <div className='meta'>
          <span className='category'>
            <a href={'#' + id + '_info'}>
              <i className='arrow alternate down icon' /> zum Text
            </a>
          </span>
        </div>
        <AutofitIFrame src={iframe} style={{ minHeight: '400px' }} />

        <div className='chapter'>
          <div className='name'>{link}</div>
        </div>
      </div>
    </div>
  )
}
